import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import PersonalInfoPage from './PersonalInfoPage';

const AddKidRoute: FuseRouteItemType = {
  path: '',
  element: <PersonalInfoPage />,
  auth: AUTH_ROLES.parent, // []
};

export default AddKidRoute;
